import _ from 'lodash';
import {connect} from 'react-redux';
import mapDispatchToProps from 'framework/hocs/connectWithCore/mapDispatchToProps';
import mapStateToProps from 'framework/hocs/connectWithCore/mapStateToProps';

// formerly connectDynamic
const connectWithCore = (component) =>
  connect(mapStateToProps, mapDispatchToProps)(component);

export default connectWithCore;
